import { useContext, useState } from 'react';
import { Button, NoticeCard } from '../../../../components';
import utils from '../../../../services/utils';

import { useSelector } from 'react-redux';

import Context from '../../../../store/context';
import DropFiles from "../../../../components/DropFiles/DropFiles/DropFiles";

import classes from './InvoicesUploadCharges.module.scss';
import { ReactComponent as File } from '../../../../assets/icons/File.svg';
import { ReactComponent as CloudArrowUp } from '../../../../assets/icons/CloudArrowUp.svg';
import { ReactComponent as ArrowDownLine } from '../../../../assets/icons/ArrowDownLine.svg';

const typeFile = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
};

const urlUploadFile = process.env.REACT_APP_MELOAPP_API_URL;

const InvoicesUploadCharges = ({ refetch }) => {
  // const navigate = useNavigate();
  const { businessId } = useSelector(state => state.userData);
  const [fileUpload, setFileUpload] = useState(null);
  const [fileStatus, setFileStatus] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const {
    modal: { hideModal, showError },
    toast: { showSuccess }
  } = useContext(Context);

  // Función para cerrar el modal con animación
  const closeModalWithAnimation = () => {
    // Buscar el modal container con un selector más específico
    const modalContainer = document.querySelector('[class*="container"][class*="visible"]');
    
    if (modalContainer) {
      // Simular click en el backdrop para activar closeHandler
      modalContainer.click();
    } else {
      // Fallback: cerrar directamente
      hideModal();
    }
  };

  const changeOtherFile = async file => {
    if (file) {
      setFileUpload(file);
      setFileStatus(0); // Reset status when new file is selected
    }
  };

  const downloadFile = () => {
    utils.downloadFileByUrl('https://meloapp-public-assets.s3.us-east-2.amazonaws.com/charges-template.xlsx');
  };

  const addInvoices = async () => {
    if (!fileUpload) return;

    setIsUploading(true);
    setFileStatus(10); // Start progress

    try {
      // 1. Solicita la URL prefirmada
      const response = await fetch(`${urlUploadFile}/invoices/generate-upload-url`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          filename: fileUpload.name,
          contentType: fileUpload.type,
          businessId,
        }),
      });


      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Error en la respuesta del servidor:', errorText);
        throw new Error(`Error generando URL de carga: ${response.status} ${response.statusText}`);
      }
      
      setFileStatus(30); // URL obtenida

      const responseData = await response.json();

      // Validar estructura de respuesta
      if (!responseData.data || !responseData.data.uploadUrl) {
        console.error('❌ Estructura de respuesta inválida:', responseData);
        throw new Error('Respuesta del servidor con estructura inválida');
      }

      const { uploadUrl } = responseData.data;

      setFileStatus(50); // URL validada

      console.log('🔵 DEBUG: Antes del PUT a S3', { uploadUrl, businessId, fileType: fileUpload.type });

      // 2. Sube el archivo a S3 usando la URL prefirmada
      const putResponse = await fetch(uploadUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': fileUpload.type,
          'x-amz-meta-business-id': businessId
        },
        body: fileUpload,
      });

      console.log('🟢 DEBUG: Después del PUT a S3', { status: putResponse.status, ok: putResponse.ok });

      if (!putResponse.ok) {
        const s3ErrorText = await putResponse.text();
        console.error('❌ Error en carga a S3:', s3ErrorText);
        throw new Error(`Error subiendo archivo a S3: ${putResponse.status} ${putResponse.statusText}`);
      }

      setFileStatus(90); // Archivo subido

      showSuccess('Archivo subido correctamente. Procesando cuentas de cobro, esto puede tomar unos segundos...');
      setFileStatus(100);

      // Cerrar el modal y hacer polling para esperar a que se creen los charges
      setTimeout(() => {
        closeModalWithAnimation();

        // Resetear el estado del archivo despues de la animacion completa
        setTimeout(() => {
          setFileUpload(null);
          setFileStatus(0);

          // Refrescar una sola vez despues de un delay para que el backend termine de procesar
          const refreshTimer = setTimeout(() => {
            if (refetch) {
              refetch();
            }
          }, 5000);

          return () => clearTimeout(refreshTimer);
        }, 500);
      }, 2000);

    } catch (error) {
      console.error('💥 Error en el proceso de carga:', error);
      showError({
        title: 'Error en la carga',
        description: error.message || 'Error desconocido durante la carga del archivo'
      });
      setFileStatus(0); // Reset status on error
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>
      <span className='bold-20'>Subir cuentas de cobro</span>
      <NoticeCard
        className={classes.notice}
        text='Para crear cuentas de cobro de clientes que no existen en Melo, primero debes crearlos desde la vista de Mis clientes.'
      />
      <div className={classes.content}>
        <span className={`${classes['download-text']} semibold-16`}>
          Descarga la plantilla de cuentas de cobro y vuelvela a subir diligenciada
        </span>
        <Button onClick={downloadFile} custom='quaternary' Icon={ArrowDownLine}>
          Descargar plantilla
        </Button>

        <span className={`medium-14 ${classes.color}`}>
          Sigue las instrucciones en la hoja "Instrucciones" del archivo Excel
        </span>

        <DropFiles
          className={classes['content-card']}
          maxSize={500000}
          typeFile={typeFile}
          maxFiles={1}
          onDroppedFiles={files => changeOtherFile(files[0])}>
          <CloudArrowUp />
          <span className={`semibold-16 ${classes.text}`}>
            {!fileUpload ? 'Arrastra tu archivo aqui o' : 'Arrastra aqui un nuevo archivo o'}
          </span>
          <Button>{!fileUpload ? 'Selecciona el archivo' : 'Seleccionar nuevo archivo'}</Button>
          <span className={`medium-14 ${classes.color}`}>Solo archivos .xlsx de maximo 500 KB</span>
        </DropFiles>

        {fileUpload && (
          <div className={classes['position-card-upload']}>
            <File />
            <div className={classes['content-file']}>
              <span className='semibold-16'>{fileUpload.name}</span>
              <div className={classes['content-progress']}>
                <div className={classes['progress']} style={{ width: `${fileStatus}%` }}></div>
              </div>
              {isUploading && (
                <span className={`medium-12 ${classes.status}`}>
                  {fileStatus < 30 && 'Solicitando URL...'}
                  {fileStatus >= 30 && fileStatus < 50 && 'Validando URL...'}
                  {fileStatus >= 50 && fileStatus < 90 && 'Subiendo a S3...'}
                  {fileStatus >= 90 && 'Completando...'}
                </span>
              )}
            </div>
          </div>
        )}
        <div className={classes.down}>
          <Button 
            onClick={addInvoices} 
            enabled={!!fileUpload && !isUploading}
            loading={isUploading}
          >
            {isUploading ? 'Subiendo...' : 'Subir cuenta'}
          </Button>
        </div>
      </div>
    </>
  );
};

export default InvoicesUploadCharges;
